import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {IconComponent} from "../icon/icon.component";
import {Icons} from "../../../model/icon";
import {ButtonIconComponent} from "../button-icon/button-icon.component";
import {NgForOf, NgIf} from "@angular/common";
import {MapIcon, MapIcons} from "../../../model/map";
import {searchInObjects} from "../../../functions/find";
import {articles} from "../../../model/article";
import {MapFilter} from "../../../model/chronology";

@Component({
  selector: 'app-searh-places',
  imports: [
    ReactiveFormsModule,
    IconComponent,
    ButtonIconComponent,
    NgForOf,
    NgIf
  ],
  templateUrl: './search-places.component.html',
  styleUrl: './search-places.component.scss'
})
export class SearchPlacesComponent implements OnInit {
  @Input() filter: MapFilter = new MapFilter();
  @Output() emitActiveTypes: EventEmitter<string[]> = new EventEmitter<string[]>();
  @Output() emitSearch: EventEmitter<string> = new EventEmitter<string>();
  constructor(private fb: FormBuilder) {
    this.searchForm = this.fb.group({
      search: [''],
    });
  }

  searchForm: FormGroup;

  active: number = 0;

  categories: MapIcon[] = [];

  search: string = '';

  onInputCode(inputElement: HTMLInputElement): void {
    const value = inputElement.value;
  }

  ngOnInit() {
    this.searchForm.get('search')!.valueChanges.subscribe(value => {
      this.search = value;
      this.emitSearch.emit(value);
    });
    this.categories = MapIcons.map(v => new MapIcon(v)).slice();
    if (this.filter.filters) {
      this.filter.filters.forEach(key => {
        const item = this.categories.find(c => c.name == key);
        if (item) {
          item.active = true;
        }
      });
    } else {
      this.categories[0].active = true;
    }
    if (this.filter.search) {
      this.search = this.filter.search;
      this.searchForm.get('search')?.setValue(this.filter.search, { emitEvent: false });
    }
  }

  activate(icon: MapIcon, index: number) {
    if (index == 0) {
      this.categories.forEach(v => v.active = false);
      icon.active = true;
    } else {
      this.categories[0].active = false;
      icon.active = !icon.active;
    }
    const arr = this.categories.slice().filter(v => v.active).map(v => v.name) ?? [];
    this.emitActiveTypes.emit(arr);
  }

  clear() {
    this.search = "";
    this.searchForm.get('search')?.setValue('', { emitEvent: false });
    this.emitSearch.emit('');
  }

  protected readonly Icons = Icons;
  protected readonly MapIcons = MapIcons;
}
